import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchChatList } from "../../redux/chatListSlice";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import Right from "./Right";

function Message() {
  const dispatch = useDispatch();
  const { chats } = useSelector((state) => state.chatList);

  useEffect(() => {
    dispatch(fetchChatList());
  }, [dispatch]);

  return (
    <>
      <Header />

      <section>
        <div className="container pt-3">
          <div className="row g-3">
            <div className="col-lg-8 col-12 mb-5">
              <div className="bg-white rounded-4">
                {/* Header */}
                <div className="p-4 pb-1 d-flex justify-content-between align-items-center">
                  <div>
                    <h3 className="fw-medium ls-sm text-dark lh-1 fs-4 m-0">
                      My Conversations ({chats.length})
                    </h3>
                    <p className="lh-sm fw-normal m-0">
                      Live Chat with your matches for free
                    </p>
                  </div>
                </div>

                {/* Tabs */}
                <div className="px-4 mt-2 d-flex">
                  <div className="py-2 px-3 border-bottom border-danger border-3 me-2">
                    <p className="lh-sm fw-normal m-0 text-danger">
                      Acceptance
                    </p>
                  </div>
                </div>

                <hr className="mt-0 mb-4" />

                {/* Chat List */}
                <div className="px-4 pb-8">
                  {chats.length === 0 ? (
                    <div className="text-center my-3">
                      <p className="my-2">No Conversations Yet</p>
                    </div>
                  ) : (
                    chats.map((chat) => (
                      <Link
                        key={chat._id}
                        to="/chat"
                        state={{ profileId: chat.receiverDetails?._id }}
                        className="d-flex justify-content-between align-items-center mb-2"
                      >
                        <div className="d-flex align-items-center">
                          <img
                            src={
                              chat.receiverDetails?.images?.[0]?.docUrl ||
                              "/assets/images/default-profile.jpg"
                            }
                            className="object-fit-cover rounded-circle"
                            width="50"
                            height="50"
                            alt={chat.receiverDetails?.name}
                          />
                          <div className="ms-3">
                            <h4 className="fw-normal ls-sm fw-medium text-dark lh-1 mt-1 mb-0">
                              {chat.receiverDetails?.name || "Unknown User"}
                            </h4>
                            <p className="d-flex text-secondary align-items-center m-0 lh-sm">
                              {chat.lastMessage || "No messages yet"}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <p className="m-0 lh-sm me-5 text-dark">
                            {(() => {
                              const chatDate = new Date(chat.createdAt);
                              const now = new Date();

                              const isToday =
                                chatDate.getDate() === now.getDate() &&
                                chatDate.getMonth() === now.getMonth() &&
                                chatDate.getFullYear() === now.getFullYear();

                              if (isToday) {
                                return chatDate.toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                });
                              } else {
                                const day = String(chatDate.getDate()).padStart(
                                  2,
                                  "0"
                                );
                                const month = String(
                                  chatDate.getMonth() + 1
                                ).padStart(2, "0");
                                const year = chatDate.getFullYear();
                                return `${day}/${month}/${year}`;
                              }
                            })()}
                          </p>

                          <div className="icon-shape icon-sm bg-light rounded-circle">
                            <i className="bi bi-chevron-right fs-4 text-dark"></i>
                          </div>
                        </div>
                      </Link>
                    ))
                  )}
                </div>
              </div>

              {/* Premium Banner */}
              <div className="px-4 mt-n6">
                <Link
                  to="/upgrade"
                  className="alert alert-warning d-flex align-items-center justify-content-between px-4 py-3 rounded-4 shadow"
                >
                  <div>
                    <h6 className="mb-0 lh-1 fw-semibold fs-5">
                      Go Premium — Connect Without Limits
                    </h6>
                    <p className="m-0 lh-sm">
                      Upgrade to unlock <strong>unlimited chat</strong> and{" "}
                      <strong>video/audio call</strong> features.
                    </p>
                  </div>
                  <div className="btn bg-dark text-white border-0 btn-sm fw-semibold px-4 rounded-pill d-lg-block d-none">
                    Upgrade
                  </div>
                </Link>
              </div>
            </div>

            <Right />
          </div>
        </div>
      </section>
    </>
  );
}

export default Message;
